import SearchModalEpisodeResults from './SearchModalEpisodeResults';

export default SearchModalEpisodeResults;
